module.exports = __webpack_public_path__ + "img/隆尧方便面.2e61dedf.jpg";